module.exports = __webpack_public_path__ + "7bfc31d398798449a4ae4524df21ec9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/img/landing/cheque_innovacion2.jpg
// module id = 340
// module chunks = 1